// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"aa844eb3","693":"50e42ece","845":"5b6da59f"}[chunkId] + ".chunk.js";
};